import script from "./CardDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./CardDetailView.vue?vue&type=script&setup=true&lang=js"

import "./CardDetailView.vue?vue&type=style&index=0&id=50262444&scoped=true&lang=css"

import exportComponent from "C:\\Users\\LEGION\\Desktop\\SONNAR\\proiBueno\\virgen\\reppsoc-ppqy9-portaltuturesweb\\reppsoc-ppqy9-portaltuturesweb\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50262444"]])

export default __exports__